var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataDriftOperation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_489_1077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2498 0.812393C1.0623 1.28114 0.937305 8.40614 0.937305 18.8749C0.937305 33.8749 0.874805 36.2186 0.468555 36.5624C-0.156445 37.0624 -0.125195 38.0936 0.499805 38.3436C0.749805 38.4374 1.1248 38.8436 1.28105 39.2499C1.6248 40.1874 2.65605 40.2499 3.1873 39.3749C3.59355 38.7499 3.93731 38.7499 20.9998 38.7499C31.5311 38.7499 38.7186 38.6249 39.1873 38.4374C40.0623 38.1249 40.2498 37.2499 39.6248 36.6249C39.3436 36.3436 34.8436 36.2499 21.3436 36.2499H3.4373V18.4999C3.4373 5.12489 3.34355 0.656143 3.0623 0.374893C2.4373 -0.250107 1.5623 -0.0626068 1.2498 0.812393Z",
    fill: "#272D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.156 0.5625C18.7498 2.1875 17.4998 4.96875 13.906 16.7188C12.4685 21.4375 10.9373 25.7188 10.0623 27.5625C7.93726 31.9062 9.06226 31 14.4373 24.0312C17.8435 19.6562 19.9685 18.125 22.8123 18.125C25.9998 18.125 28.0623 19.5938 32.3435 24.9688C33.9373 26.9688 35.7498 29.0938 36.3748 29.6875L37.531 30.7812L36.4685 28.75C35.4685 26.8438 34.6248 24.3438 30.6248 12.0312C28.8123 6.4375 27.0623 2.8125 25.4998 1.28125C24.156 -0.03125 22.4373 -0.3125 21.156 0.5625Z",
    fill: "#272D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0938 20.8438C19.6562 21.5625 18 23.2812 15.3125 26.7188C12.25 30.6562 10.5 32.3438 8.5625 33.2812L7.03125 34.0312H19.8438C30.3125 34 40.0625 33.7188 37.7812 33.5C36.7188 33.375 34.25 31.0938 31.2812 27.4062C27.5938 22.8438 26.1562 21.4375 24.625 20.7812C23.1562 20.1875 22.2812 20.1875 21.0938 20.8438Z",
    fill: "#272D55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_489_1077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataDriftOperation);
export default __webpack_public_path__ + "static/media/DataDriftOperation.6e640d92f4d56a184a37eee0ab717139.svg";
export { ForwardRef as ReactComponent };